module.exports = __webpack_public_path__ + "img/landing-1-hu-HU.8194e64.png";